



















































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import * as service from '@/services/prescription';
import { Prop, Watch } from 'vue-property-decorator';
import { getReasons } from '@/services/parameters';

@Component({
  components: {},
  directives: {}
})
export default class CancelPrescriptionDialog extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  opcaoExcluir;

  dialogFlag = false;
  reasons: any[] = [];
  reason: any = null;
  formOpen = false;
  loadingReasons = false;
  group = [];
  ids = [];
  loadingGroup = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo']
  };

  public form: any = {
    valid: false
  };

  public beforeMount(): void {
    const filter = {
      idMedico: this.item.medico.id,
      idUnidade: this.item.unidade.id
    };

    this.loadingReasons = true;
    getReasons(filter).subscribe((data) => {
      this.reasons = data.valores || [];
      this.loadingReasons = false;
    });
  }

  @Watch('opcaoExcluir', { immediate: true })
  private onOpcaoExcluirChange(val: boolean) {
    if (!val) {
      return;
    }

    this.loadingGroup = true;
    service.getDeletePrescriptionGroup(this.item.idPrescricao).subscribe(
      (res) => {
        this.loadingGroup = false;
        this.group = res;
      },
      (error) => {
        this.loadingGroup = false;
        this.showToastApiError(error);
      }
    );
  }

  mounted() {
    this.formOpen = true;
  }

  private getLabelBotaoQtdePresc() {
    if ((this.item && this.item.quantidade && this.item.quantidade > 1) || this.ids.length) {
      return ` ( ${this.item.quantidade * (this.ids.length + 1)} Prescrições )`;
    }
    return '';
  }

  public onReject(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Atualizando status...');

    var observable = null;
    if (this.opcaoExcluir) {
      let parm = new service.PrescricaoExclusaoParmDTO();
      parm.idsPrescricao = Object.assign(new Array(), this.ids);
      parm.idsPrescricao.push(this.item.idPrescricao);
      parm.idMotivo = this.reason.id;
      observable = service.deletePrescription(parm);
    } else {
      observable = service.cancelPrescription(this.item.idPrescricao, this.reason.id);
    }
    this.addSubsc(
      observable.subscribe(
        (data) => {
          this.loader.stop();
          this.closeForm();
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      )
    );
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  selectAll() {
    this.ids = this.group.map((g) => g.id);
  }

  removeAllSelected() {
    this.ids = [];
  }
}
